// extracted by mini-css-extract-plugin
module.exports = {"formHeader":"Reservation_formHeader__35fVB","reservationsList":"Reservation_reservationsList__1hgl5","entry":"Reservation_entry__1-vYY","status":"Reservation_status__1f0KA"};